// authHttp.js
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHttp = axios.create({
    baseURL: BACKEND_URL,
    withCredentials: true,
});

// 🌐 Signal the network layer on connection failures (no response) so the
// global OfflineFallback can take over instead of surfacing an error toast.
authHttp.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error?.response) {
            window.dispatchEvent(new Event("network-error"));
        }
        return Promise.reject(error);
    }
);

export default authHttp;